"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributeValueContainsToken = attributeValueContainsToken;

/** @hidden */
function attributeValueContainsToken(attributeName, token) {
  return "[" + attributeName + "~=\"" + token + "\"]";
}